import { BuilderUI } from "@circle-react-shared/BuilderUI";

export const DefaultCanvasControls = () => (
  <BuilderUI.CanvasControls className="bg-primary absolute bottom-6 left-1/2 -translate-x-1/2 !gap-0 rounded-xl border shadow-lg">
    <BuilderUI.CanvasSizeToggle className="rounded-r-none" />
    <div className="bg-overlay-dark mx-1 h-6 w-px" />
    <BuilderUI.CanvasAppearanceToggle className="rounded-none" />
    <div className="bg-overlay-dark mx-1 h-6 w-px" />
    <BuilderUI.CanvasZoomStepper className="rounded-l-none" />
  </BuilderUI.CanvasControls>
);
